/**
 * Runtime Configuration
 *
 * Reads from window.__RUNTIME_CONFIG__ which is set by /config.js
 * In Docker, config.js is generated by entrypoint.sh with environment variables
 */

declare global {
  interface Window {
    __RUNTIME_CONFIG__: RuntimeConfig;
  }
}

export interface RuntimeConfig {
  API_BASE_URL: string;
  CONTACT_URL: string;
  IMAGE_URL: string;
  TV_APP_URL: string;
  TABLET_AND_MOBILE_APP_URL: string;
  HOTEL_WIFI_API_URL?: string;
  CAPTIVE_PORTAL_URL?: string;
  ONESIGNAL_APP_ID?: string;
  ENVIRONMENT: string;
}

function getConfig(): RuntimeConfig {
  if (!window.__RUNTIME_CONFIG__) {
    console.warn('Runtime config not found, using defaults');
    return {
      API_BASE_URL: 'https://d-api.hotelsmarters.com',
      CONTACT_URL: 'https://notify.inorain.com/hotels-help-center',
      IMAGE_URL: 'https://d-api.hotelsmarters.com/media-library',
      TV_APP_URL: 'https://d-tv.hotelsmarters.com',
      TABLET_AND_MOBILE_APP_URL: 'https://d-mobile.hotelsmarters.com',
      HOTEL_WIFI_API_URL: '',
      CAPTIVE_PORTAL_URL: '',
      ONESIGNAL_APP_ID: 'da97b87b-fca5-45cc-85b2-bf115f5e1c64',
      ENVIRONMENT: 'development'
    };
  }
  return window.__RUNTIME_CONFIG__;
}

export function getApiBaseUrl(): string {
  return getConfig().API_BASE_URL;
}

export function getContactUrl(): string {
  return getConfig().CONTACT_URL;
}

export function getImageUrl(): string {
  return getConfig().IMAGE_URL;
}

export function getTvAppUrl(): string {
  return getConfig().TV_APP_URL;
}

export function getTabletAndMobileAppUrl(): string {
  return getConfig().TABLET_AND_MOBILE_APP_URL;
}

export function getHotelWifiApiBaseUrl(): string {
  const u = getConfig().HOTEL_WIFI_API_URL;
  if (typeof u !== 'string' || !u.trim()) {
    return '';
  }
  return u.replace(/\/$/, '');
}

export function getCaptivePortalUrl(): string {
  const u = getConfig().CAPTIVE_PORTAL_URL;
  if (typeof u !== 'string' || !u.trim()) {
    return '';
  }
  return u.replace(/\/$/, '');
}

export function getOneSignalAppId(): string {
  const id = getConfig().ONESIGNAL_APP_ID;
  if (typeof id !== 'string' || !id.trim()) {
    return '';
  }
  return id.trim();
}

export function getEnvironment(): string {
  return getConfig().ENVIRONMENT;
}

export function isDevelopment(): boolean {
  return getConfig().ENVIRONMENT === 'development';
}

export function isProduction(): boolean {
  return getConfig().ENVIRONMENT === 'production';
}

export function isStaging(): boolean {
  return getConfig().ENVIRONMENT === 'stage';
}
